import { Route, Routes } from "react-router";

import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";
import useErrorHandle from "hooks/useErrorHandle";

import VCSIntegrationFeedback from "../VcsShared/components/IntegrationFeedback";
import VCSIntegrationHeader from "./Header";
import VCSIntegrationTroubleshooting from "./Troubleshooting";
import VCSIntegrationNewUsedBy from "./UsedBy";
import { useVCSIntegration } from "./useVCSIntegration";

const VCSIntegrationNew = () => {
  const { integration, isPageLoading, error, totalEntitiesCount } = useVCSIntegration();

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (isPageLoading) {
    return <PageLoading />;
  }

  if (!integration) {
    return <NotFoundPage />;
  }

  return (
    <>
      <VCSIntegrationHeader integration={integration} totalEntitiesCount={totalEntitiesCount} />
      <VCSIntegrationFeedback integration={integration} viewPageMode />
      <Routes>
        <Route index element={<VCSIntegrationNewUsedBy />} />
        <Route
          path="troubleshooting"
          element={<VCSIntegrationTroubleshooting integration={integration} />}
        />
      </Routes>
    </>
  );
};

export default VCSIntegrationNew;
